import { Link } from "@bcm-dev/bcms-vite";
import InfoAlertNotificationView from "compid/shared/views/Notifications/InfoNotificationView/components/InfoAlertNotificationView";
import "./styles.css";

export default function RepeatPaymentPrompt(props) {
    return (
        <InfoAlertNotificationView 
            className="repeat-payment-prompt"
            textClass=""
            text={
                <div className="flex-container flex-horizontal align-center space-between text-container">
                    <p className="blue-text">Make this a repeat payment</p>

                    <div className="flex-container flex-horizontal align-right justify-right links-container">
                        <Link to={`/addAutopayWorkflow/${ props.billerID }`} className="blue-text set-width">Setup autopay</Link>
                    </div>
                </div>
            } />
    );
}